import { Duty } from 'RestAPIs/roster/types';

type Period = {
  startTime?: string;
  endTime?: string;
  start?: string;
  end?: string;
};

export const getPeriodsInterval = (periods: Period[]) => ({
  startTime: periods[0].startTime || periods[0].start || '',
  endTime:
    periods[periods.length - 1].endTime || periods[periods.length - 1].end || ''
});

export const DutyUtils = {
  hashCode: (duty: Duty): string => {
    if (!duty.dutyCode) return '';
    const dutyHourTypeCodes =
      duty.periods
        ?.map((period) => period.dutyHourType?.code)
        .filter(Boolean)
        .join(',') || '';
    const key = `${duty.dutyCode?.code}-${dutyHourTypeCodes}`;
    return key;
  }
};
